// angular import
import { Component, ViewChild, ElementRef } from '@angular/core';
// importing the superclass
import { Module } from './../module.component';
// services import
import { Status } from './../../service/status.service';
import { StockService } from './stock.service';

// component definition
@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  providers:
  [
    StockService
  ]
})
export class StockComponent extends Module {
  // input values
  private companyCode =                       '';
  private supCode =                           '';
  private language =                          '';
  private type =                              'M';

  // form object values
  @ViewChild('type_form') type_form:          ElementRef;

  constructor(private stockService:           StockService,
              private status:                 Status) {
    super();
    this.setBindExposer(this.status.getExposer());
    this.getExposer().getModelsManager().stock_request;

    this.setFormEnable(this.getCustomizingService().getBoolean('STOCK.LIST.FORM.ENABLE', false));
    this.setAutoSearchEnable(this.getCustomizingService().getBoolean('STOCK.LIST.AUTOSEARCH.ENABLE', false));

    this.requestModelSetUp();
    if (this.getAutoSearchEnable()) {
      this.doSearch();
    }
  }

  // set up the request model
  requestModelSetUp() {
    this.companyCode = this.getAccountService().getUserCompany().code;
    this.getModelsManager().stock_request.company_code = this.companyCode;
    this.supCode = this.getAccountService().supplierProperties.supplier_code;
    this.getModelsManager().stock_request.supplier_code = this.supCode;
    this.language = this.getLocale().getPreferredLanguage();
    this.getModelsManager().stock_request.language = this.language;
    this.getModelsManager().stock_request.type = this.type;
  }

  // send the query to the server
  doSearch() {
    this.getModelsManager().stock_request.type = this.type;
    this.stockService.searchStocks();
    this.switchSSP();
  }

  // return true if service is stil searching
  isServiceSearching() {
    return this.stockService.isSeraching();
  }
  // returns the status of the server query
  isResultEmpty() {
    return this.stockService.getStocks().length === 0;
  }

  getStockServiceResponse() {
    return this.getOrderedList(this.stockService.getStocks(), this.sortType, this.sortReverse);
  }

  getRequestModel() {
    return this.getModelsManager().stock_request;
  }

  // check the type value setted
  getIfChecked(value: string) {
    if (this.type === value) {
        return true;
    } else {
        return false;
    }
  }

  // method that handles the change of the type field
  setTypeValue(value: string) {
    this.type = value;
    this.getModelsManager().stock_request.type = this.type;
  }

  // clear the input values
  clearFormValues() {
    this.type = 'A';
    this.requestModelSetUp();
  }

  exportExcel() {
    this.stockService.exportExcel(this.companyCode, this.supCode, this.language, this.type);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/stock/stock.component.ts